import { render } from "./info-content.vue?vue&type=template&id=cdfd5fe4&scoped=true"
import script from "./info-content.vue?vue&type=script&lang=js"
export * from "./info-content.vue?vue&type=script&lang=js"

import "./info-content.vue?vue&type=style&index=0&id=cdfd5fe4&scoped=true&lang=css"

import exportComponent from "/var/lib/jenkins/workspace/div2-univRenewal-trunk-production/web/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-cdfd5fe4"]])

export default __exports__